'use strict';

import { validator } from '..';

const $lang = document.documentElement.lang == 'es' ? 'es' : 'pt';

const messages = {
  completeName: {
    pt: 'Digite seu nome completo.',
    es: 'Introduce tu nombre completo.',
  },
  requiredField: {
    pt: 'Campo obrigatório.',
    es: 'Campo obligatorio.',
  },
  invalidDocument: {
    pt: 'CPF inválido.',
    es: 'DNI inválido.',
  },
};

export const stepFiveValidate = () => {
  const fieldsRules = {
    ignore: false,
    rules: {
      name: {
        required: true,
        minlength: 5,
      },
      corporate_email: {
        required: true,
        email: true,
      },
      cpf: {
        required: true,
        minlength: function() {
          if (document.documentElement.lang === 'pt-BR') {
            return 14;
          } else {
            return false;
          }
        },
      },
      phone: {
        required: true,
      },
      company_id: {
        required: true,
        notOnlyZero: '0',
      },
      unity_id: {
        required: true,
        notOnlyZero: '0',
      },
      organization_type: {
        required: true,
      },
      country_id: {
        required: true,
        notOnlyZero: '0',
      },
      state_id: {
        required: true,
        notOnlyZero: '0',
      },
      city_id: {
        required: true,
        notOnlyZero: '0',
      },
      inep: {
        required: function(target) {
          return $(target).is(':visible');
        },
      },
      school_name: {
        required: function(target) {
          return $(target).is(':visible');
        },
      },
      rede: {
        required: function(target) {
          return $(target).is(':visible');
        },
      },
      cnpj: {
        required: function(target) {
          return $(target).is(':visible');
        },
      },
      organization_name: {
        required: function(target) {
          return $(target).is(':visible');
        },
      },
      area: {
        required: function(target) {
          return $(target).is(':visible');
        },
      },
      title: {
        required: true,
      },
      start_at: {
        required: true,
      },
      end_at: {
        required: true,
      },
      average_hour: {
        required: true,
      },
      impacted_people: {
        required: true,
      },
      material_possessions_donation: {
        required: function(target) {
          return $(target).is(':visible');
        },
      },
      'action_registration_file[]': {
        required: function(target) {
          return $('[name="material_possessions_donation"]').is(':visible');
        },
      },
      'activity_worksheet_file[]': {
        required: true,
        filesize: 20,
      },
      'volunteer_work_terms_file[]': {
        required: true,
        filesize: 20,
      },
      'confirmation_doc_file[]': {
        required: true,
        filesize: 20,
      },
      use_terms: {
        required: true,
      },
      volunteer_work_terms: {
        required: true,
      },
    },
    messages: {
      name: {
        required: messages.requiredField[$lang],
        minlength: messages.completeName[$lang],
      },
      corporate_email: {
        required: messages.requiredField[$lang],
        email: 'Email inválido.',
      },
      cpf: {
        required: messages.requiredField[$lang],
        minlength: messages.invalidDocument[$lang],
      },
      phone: {
        required: messages.requiredField[$lang],
      },
      company_id: {
        required: messages.requiredField[$lang],
      },
      unity_id: {
        required: messages.requiredField[$lang],
      },
      organization_type: {
        required: messages.requiredField[$lang],
      },
      country_id: {
        required: messages.requiredField[$lang],
      },
      state_id: {
        required: messages.requiredField[$lang],
      },
      city_id: {
        required: messages.requiredField[$lang],
      },
      inep: {
        required: messages.requiredField[$lang],
      },
      school_name: {
        required: messages.requiredField[$lang],
      },
      rede: {
        required: messages.requiredField[$lang],
      },
      cnpj: {
        required: messages.requiredField[$lang],
      },
      organization_name: {
        required: messages.requiredField[$lang],
      },
      area: {
        required: messages.requiredField[$lang],
      },
      title: {
        required: messages.requiredField[$lang],
      },
      start_at: {
        required: messages.requiredField[$lang],
      },
      end_at: {
        required: messages.requiredField[$lang],
      },
      average_hour: {
        required: messages.requiredField[$lang],
      },
      impacted_people: {
        required: messages.requiredField[$lang],
      },
      material_possessions_donation: {
        required: messages.requiredField[$lang],
      },
      'action_registration_file[]': {
        required: messages.requiredField[$lang],
      },
      'activity_worksheet_file[]': {
        required: messages.requiredField[$lang],
      },
      'volunteer_work_terms_file[]': {
        required: messages.requiredField[$lang],
      },
      'confirmation_doc_file[]': {
        required: messages.requiredField[$lang],
      },
      use_terms: {
        required: messages.requiredField[$lang],
      },
      volunteer_work_terms: {
        required: messages.requiredField[$lang],
      },
    },
  };

  validator('.js-validate', fieldsRules);
};
